<svg  style="display: block; margin: auto"></svg>